import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

import { Loadable } from '../components/Loadable';
import Layout from '../Layout/Layout';
import Investment from '../pages/investment';
import LoanRequest from '../pages/loanRequest';
import { ProtectedRoute } from '../components/ProtectedRoute';

const Banks = Loadable(lazy(() => import('../pages/bank')));
const CreateBanks = Loadable(lazy(() => import('../pages/bank/Edit')));
const EditBanks = Loadable(lazy(() => import('../pages/bank/New')));
const Debt = Loadable(lazy(() => import('../pages/debt')));
const System = Loadable(lazy(() => import('../pages/config/system')));
const Budget = Loadable(lazy(() => import('../pages/budget')));
const Community = Loadable(lazy(() => import('../pages/community')));
const Interests = Loadable(lazy(() => import('../pages/interests')));
const Investments = Loadable(lazy(() => import('../pages/config/investments')));
const Panel = Loadable(lazy(() => import('../pages/panel')));
const CalendarPage = Loadable(lazy(() => import('../pages/calendar')));
const Payments = Loadable(lazy(() => import('../pages/payments')));
const EditPayment = Loadable(lazy(() => import('../pages/payments/Edit')));
const Permissions = Loadable(lazy(() => import('../pages/permissions')));
const Profile = Loadable(lazy(() => import('../pages/profile')));
const Roles = Loadable(lazy(() => import('../pages/roles')));
const Users = Loadable(lazy(() => import('../pages/users')));
const Withdrawal = Loadable(lazy(() => import('../pages/Withdrawal')));
const FinancialStatements = Loadable(
	lazy(() => import('../pages/config/financialStatements'))
);
const Amortization = Loadable(
	lazy(() => import('../pages/config/amortization'))
);
const CreditPortfolio = Loadable(
	lazy(() => import('../pages/config/CreditPortfolio'))
);
const InvestmentRounds = Loadable(
	lazy(() => import('../pages/config/InvestmentRounds'))
);
const LoanRequests = Loadable(
	lazy(() => import('../pages/config/LoanRequests'))
);
const WithdrawalRequests = Loadable(
	lazy(() => import('../pages/config/withdrawalRequest'))
);
const FinancialAssistance = Loadable(
	lazy(() => import('../pages/config/financialAssistance'))
);
const EditProfile = Loadable(
	lazy(() => import('../pages/profile/Components/editProfile'))
);
const Transactions = Loadable(
	lazy(() => import('../pages/config/transactions'))
);
const ConfigurationInterest = Loadable(
	lazy(() => import('../pages/config/interest'))
);
const FamilyGroups = Loadable(
	lazy(() => import('../pages/config/familyGroups'))
);
const mainRoutes = {
	path: '/',
	element: <Layout />,
	children: [
		{
			path: '/dashboard',
			children: [
				{
					path: '',
					element: <Navigate to="panel" replace />,
				},
				{
					path: 'panel',
					element: <Panel />,
				},
				{
					path: 'calendar',
					element: <CalendarPage />,
				},
				{
					path: 'investment',
					element: <Investment />,
				},
				{
					path: 'budget',
					element: <Budget />,
				},
				{
					path: 'interests',
					element: <Interests />,
				},
				{
					path: 'debt',
					element: <Debt />,
				},
				{
					path: 'loanRequest',
					element: <LoanRequest />,
				},
				{
					path: 'withdrawal',
					element: <Withdrawal />,
				},
				{
					path: 'community',
					element: <Community />,
				},
				{
					path: 'account',
					children: [
						{
							path: 'user_profile',
							element: <Profile />,
						},
						{
							path: 'edit_profile',
							element: <EditProfile />,
						},
					],
				},
			],
		},
		{
			path: 'configuration',
			children: [
				{
					path: 'permissions',
					element: (
						<ProtectedRoute element={<Permissions />} requiredRole="admin" />
					),
				},
				{
					path: 'roles',
					element: <ProtectedRoute element={<Roles />} requiredRole="admin" />,
				},
				{
					path: 'master_data',
					children: [
						{
							path: 'users',
							element: (
								<ProtectedRoute element={<Users />} requiredRole="admin" />
							),
						},
						//   {
						//      path: 'users/:id/edit',
						//      element: (
						//         <ProtectedRoute
						//            element={<UserEdit />}
						//            requiredRole="admin"
						//         />
						//      ),
						//   },
						//   {
						//      path: 'users/create',
						//      element: (
						//         <ProtectedRoute
						//            element={<NewUser />}
						//            requiredRole="admin"
						//         />
						//      ),
						//   },
						{
							path: 'banks',
							element: (
								<ProtectedRoute element={<Banks />} requiredRole="admin" />
							),
						},
						{
							path: 'banks/create',
							element: (
								<ProtectedRoute
									element={<CreateBanks />}
									requiredRole="admin"
								/>
							),
						},
						{
							path: 'banks/:id/edit',
							element: (
								<ProtectedRoute element={<EditBanks />} requiredRole="admin" />
							),
						},
						//TODO: Renombrar todo esto a type_transactions
						{
							path: 'transactions',
							element: (
								<ProtectedRoute
									element={<h1>Transacciones</h1>}
									requiredRole="admin"
								/>
							),
						},
						// {
						//    path: 'transactions/create',
						//    element: (
						//       <ProtectedRoute
						//          element={<TransactionsMasterEdit />}
						//          requiredRole="admin"
						//       />
						//    ),
						// },
						// {
						//    path: 'transactions/:id/edit',
						//    element: (
						//       <ProtectedRoute
						//          element={<TransactionsMasterCreate />}
						//          requiredRole="admin"
						//       />
						//    ),
						// },
					],
				},
				{
					path: 'administration',
					children: [
						{
							path: 'interests',
							element: (
								<ProtectedRoute
									element={<ConfigurationInterest />}
									requiredRole="admin"
								/>
							),
						},
						{
							path: 'family_groups',
							element: (
								<ProtectedRoute
									element={<FamilyGroups />}
									requiredRole="admin"
								/>
							),
						},
						{
							path: 'payments',
							element: (
								<ProtectedRoute element={<Payments />} requiredRole="admin" />
							),
						},
						{
							path: 'payments/edit/:id',
							element: (
								<ProtectedRoute
									element={<EditPayment />}
									requiredRole="admin"
								/>
							),
						},
						{
							path: 'investments',
							element: (
								<ProtectedRoute
									element={<Investments />}
									requiredRole="admin"
								/>
							),
						},
						{
							path: 'transactions',
							element: (
								<ProtectedRoute
									element={<Transactions />}
									requiredRole="admin"
								/>
							),
						},
						{
							path: 'financial_assistance',
							element: (
								<ProtectedRoute
									element={<FinancialAssistance />}
									requiredRole="admin"
								/>
							),
						},
						{
							path: 'loan_requests',
							element: (
								<ProtectedRoute
									element={<LoanRequests />}
									requiredRole="admin"
								/>
							),
						},
						{
							path: 'withdrawal_requests',
							element: (
								<ProtectedRoute
									element={<WithdrawalRequests />}
									requiredRole="admin"
								/>
							),
						},
						{
							path: 'investment_rounds',
							element: (
								<ProtectedRoute
									element={<InvestmentRounds />}
									requiredRole="admin"
								/>
							),
						},
						{
							path: 'credit_portfolio',
							element: (
								<ProtectedRoute
									element={<CreditPortfolio />}
									requiredRole="admin"
								/>
							),
						},
						{
							path: 'amortizations',
							element: (
								<ProtectedRoute
									element={<Amortization />}
									requiredRole="admin"
								/>
							),
						},
						{
							path: 'financial_statements',
							element: (
								<ProtectedRoute
									element={<FinancialStatements />}
									requiredRole="admin"
								/>
							),
						},
					],
				},
				{
					path: 'settings',
					children: [
						{
							path: 'system',
							element: (
								<ProtectedRoute element={<System />} requiredRole="admin" />
							),
						},
					],
				},
			],
		},
	],
};

export default mainRoutes;
